<template>
	<div class="agreement_page">
		<div class="agreement_title">{{info.title}}</div>
		<div class="agreement_content" v-html="info.content"></div>
	</div>
	<!-- <div class="web-page">
		<div>
			<p style="text-align:center;">
				浙江国际赛车场
			</p>
			<p>
				赛道驾驶活动承诺书
			</p>
			<p>
				【声明】：
			</p>
			<p>
				赛车和赛道驾驶是一项极具危险性、不可预见的运动。制定此承诺书是让参与者更多地&nbsp;了解赛车和赛道驾驶活动中存在的风险，提高自己的安全意识，规范自己的行为，对自己负&nbsp;责，对同行参与者负责。本承诺书是有关赛车和赛道驾驶活动的责任豁免、权利放弃、风险&nbsp;承担和赔偿责任放弃。为了让赛车和赛道驾驶活动更精彩、更安全、更快乐，请仔细阅读，&nbsp;理解并签署本承诺书。
			</p>
			<p>
				一、风险承担
			</p>
			<p>
				本人了解、接受并承认，因场地、天气、温度、车辆等设施设备情况、其他人员的作为&nbsp;或者不作为等因素，在浙江国际赛车场场地内使用赛道、场地或场地内的设施设备和服务，&nbsp;以及在赛车场区域内活动，均存在危险，可能会引起人身伤害、死亡和财产损失。本人经慎&nbsp;重考虑，&nbsp;并且在了解、接受并承认上述风险和危险的前提下，特此表示完全出于自愿参加并&nbsp;同意自行承担全部风险。本人进一步做出以下承诺：
			</p>
			<p>
				1．本人身体和精神状况均良好，无任何不适合或可能不适合进行赛车运动或驾驶活动的疾病或其他医学状况，并且不存在任何其他原因或因素将会或可能影响本人的驾驶能力或&nbsp;限制本人进行一切赛车和驾驶活动。任何可能影响本人控制车辆的不适、损伤、病痛或其它&nbsp;疾病，&nbsp;无论是永久的还是临时性的，都有可能对本人和其他人造成危险，本人保证在上述情&nbsp;况下不参加赛车和驾驶活动。本人进一步保证，如在参加赛车和驾驶活动期间发生上述情况，&nbsp;本人应停止一切赛车和驾驶活动。并且离开赛车场区域。若本人违反前述承诺保证，由本人&nbsp;自行承担由此产生的全部责任以及发生的全部费用。若给浙江国际赛车场或第三方造成损失，本人应予以赔偿，包括但不仅限于承担浙江国际赛车场的维修费用、为维权支付的诉讼&nbsp;费、律师代理费、鉴定费及其他实际支出的费用。
			</p>
			<p>
				2．本人不在饮酒后或服用致幻剂或其他可能影响其判断力的药物或物质后使用浙江国际赛车场的赛道、场地或场地内的设施设备。若本人违反前述承诺保证，浙江国际赛车场有&nbsp;权暂停或取消本人使用浙江国际赛车场场地和设施设备的权利，由本人自行承担因此产生的&nbsp;全部责任以及发生的全部费用。若给浙江国际赛车场或第三方造成损失，由本人应予以赔偿，&nbsp;包括但不仅限于承担浙江国际赛车场的维修费用、为维权支付的诉讼费、律师代理费、鉴定&nbsp;费及其他实际支出的费用。
			</p>
			<p>
				3．本人同意自行承担，因在浙江国际赛车场使用任何场地、器材、工具、设备、设施&nbsp;以及服务，包括但不限于使用赛道、车辆，或进行练习或比赛，或参与在浙江国际赛车场内&nbsp;的任何活动时，无论上述项目是否为浙江国际赛车场拥有、运营、租借的还是本人自行携带&nbsp;来的，&nbsp;所引起的、产生的或与之相关的人身伤害、财产损失或其他全部责任以及发生的全部&nbsp;费用；若给浙江国际赛车场或第三方造成损失，由本人自行承担全部责任，包括但不仅限于&nbsp;承担浙江国际赛车场的维修费用、为维权支付的诉讼费、律师代理费、鉴定费及其他实际支&nbsp;出的费用。本人特此免除浙江国际赛车场及其实际控制人、附属机构或其他附属企业，以及&nbsp;任何与浙江国际赛车场有关的机构、团体(包括但不仅限于汽联、赞助商、任何场地、 器材、&nbsp;工具、设备、设施的所有权人、出租方、运营方、活动主办方) 、他们的股东、董事、 高级&nbsp;管理人员、成员、雇员、顾问、代表、代理、继承人、受让人，以及其他参与选手或参加者&nbsp;	(以下单独或合称为“浙江国际赛车场方”) 因在浙江国际赛车场场地内使用赛道、场地或场地内的设施设备或服务，或在赛车场区域内活动引起的、产生的或与之相关的任何及全部&nbsp;经济和法律责任，并且本人承诺，在法律允许的最大范围内，本人、本人亲属、继承人、法&nbsp;律代表、其他授权代表和受让人，均彻底放弃并且不会向浙江国际赛车场方提出任何索赔、权利主张或追究法律责任的要求。
			</p>
		</div>
		<p style="text-indent:2em;">
			<br />
		</p>
		<div style="text-indent:2em;">
			<p>
				4．本人知晓浙江国际赛车场不提供与本人的行为或在浙江国际赛车场场地进行活动所引起的损失和伤亡相关的任何保险。浙江国际赛车场建议本人或本人的代表(或父母或监护 人)自付费用选择购买覆盖因本人的行为或在浙江国际赛车场场地进行活动所引起的所有损 失和伤亡相关的保险。
			</p>
			<p>
				二、&nbsp;活动规则
			</p>
			<p>
				本人了解、接受、承认并同意：
			</p>
			<p>
				1．本人在浙江国际赛车场内的一切行为举止都必须符合法律法规，并且遵从浙江国际赛车场安排及指挥。
			</p>
			<p>
				2．本人只能使用浙江国际赛车场指定的区域和赛道，而不得进入浙江国际赛车场限定的禁区。本人只能在浙江国际赛车场批准的前提下，才能在赛道上驾驶车辆或进行其他活动。
			</p>
			<p>
				3．本人应确保自行熟悉、理解并严格遵守赛道旗语，必须时刻遵从浙江国际赛车场的指令，&nbsp;若本人未能遵从浙江国际赛车场发布的信号或指令，浙江国际赛车场有权暂停或禁止&nbsp;本人继续使用赛道或进行任何活动。
			</p>
			<p>
				4．浙江国际赛车场可出于安全因素考虑，或者由于本人违反法律法规、赛车场的规定&nbsp;	(包括但不限于本承诺书)，或者任何其他合理原因，暂停或取消本人使用浙江国际赛车场 的任何场地、器材、工具、设备、设施以及服务的权利。
			</p>
			<p>
				5．若违反前述活动规则，本人同意按本承诺书附件1《浙江国际赛车场赛道活动违规 处罚明细表》接受浙江国际赛车场的处罚，并承担由此产生的全部责任以及发生的全部费用。&nbsp;本人进一步同意，对浙江国际赛车场内任何场地、器材、工具、设备或设施遗失或损坏的赔&nbsp;偿标准按本承诺书附件2《浙江国际赛车场赛道固定资产损坏修复费表》执行。
			</p>
			<p>
				6．若因本人或本人亲属、继承人、法律代表、其他授权代表或受让人原因引起涉及浙江国际赛车场方的诉讼，本人同意承担浙江国际赛车场方为维权支付的诉讼费、律师代理费、&nbsp;鉴定费及其他实际支出的费用。本人与第三方产生的纠纷，在本人方与第三方之间自行解决，&nbsp;本人同意浙江国际赛车场方对此不承担任何责任。
			</p>
			<p>
				三、&nbsp;管辖法院
			</p>
			<p>
				本人同意对于所有因本承诺书的解释、执行或终止所发生的争议，应提交浙江国际赛车&nbsp;场所在地法院解决。
			</p>
			<p>
				四、未成年人附加免责声明
			</p>
			<p>
				1．18 周岁以下的未成年人，必须由监护人陪同，或具有监护人签字的书面免责声明，&nbsp;否则不能进入浙江国际赛车场活动场所进行活动。
			</p>
			<p>
				2．对于进入场地、进行活动但又存在隐瞒真实年龄、提供虚假监护人或者伪造监护人签字等欺骗行为的未成年人，浙江国际赛车场不承担任何法律和道德上的责任。
			</p>
			<p>
				本人特此承认并声明，(1)&nbsp;本人已年满&nbsp;18&nbsp;周岁，并且具有完全民事行为能力；(2)&nbsp;本&nbsp;人已经仔细阅读并理解了以上承诺书及其条文，并已经咨询过律师，签署本承诺书代表本&nbsp;人完全理解、接受和同意有关在浙江国际赛车场场地内使用赛道、场地、场地内的设施设&nbsp;备和服务，以及在赛车场区域内活动期间责任的豁免、法律权利的放弃、以及风险的承担&nbsp;之事宜；并且，(3)&nbsp;本承诺书对本人、本人亲属、继承人、法律代表、其他授权代表和受&nbsp;让人具有约束力。
			</p>
			<p>
				&nbsp;
			</p>
		</div>
		<div style="text-indent:2em;">
			<p>
				附件&nbsp;1：浙江国际赛车场违规处罚明细
			</p>
			<p>
				&nbsp;
			</p>
			<p>
				&nbsp;
			</p>
			<table border="1">
				<tbody>
					<tr>
						<td>
							<p>
								序号&nbsp;No.
							</p>
						</td>
						<td>
							<p>
								违规内容
							</p>
							<p>
								Infringement
							</p>
						</td>
						<td>
							<p>
								罚金(人民币)Fine&nbsp;(RMB)
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								1
							</p>
						</td>
						<td>
							<p>
								车辆在赛道关闭时闯入赛道
							</p>
							<p>
								Vehicles&nbsp;entering&nbsp;track while track closed
							</p>
						</td>
						<td>
							<p>
								20,000 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								2
							</p>
						</td>
						<td>
							<p>
								晚&nbsp;10 点至早 7 点发动引擎
							</p>
							<p>
								Starting&nbsp;engines&nbsp;from&nbsp;10pm&nbsp;to 7am
							</p>
						</td>
						<td>
							<p>
								10,000 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								3
							</p>
						</td>
						<td>
							<p>
								在维修通道或赛道逆行或倒车
							</p>
							<p>
								Going in the wrong direction or reversing vehicles in the&nbsp;pitlane&nbsp;or&nbsp;on&nbsp;track
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								2,000 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								4
							</p>
						</td>
						<td>
							<p>
								在维修通道给车注入燃料
							</p>
							<p>
								Refuelling&nbsp;in&nbsp;the&nbsp;pitlane
							</p>
						</td>
						<td>
							<p>
								1,000 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								5
							</p>
						</td>
						<td>
							<p>
								故意在赛道区域内烧胎
							</p>
							<p>
								Purposely&nbsp;spinning&nbsp;wheels&nbsp;in&nbsp;the&nbsp;circuit
							</p>
						</td>
						<td>
							<p>
								500 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								6
							</p>
						</td>
						<td>
							<p>
								故意驾车碾压草坪
							</p>
							<p>
								Purposely&nbsp;driving&nbsp;onto&nbsp;the&nbsp;grass
							</p>
						</td>
						<td>
							<p>
								500 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								7
							</p>
						</td>
						<td>
							<p>
								在安全车/医疗车内乱丢杂物垃圾
							</p>
							<p>
								Littering&nbsp;in&nbsp;Safety&nbsp;/Medical&nbsp;Cars
							</p>
						</td>
						<td>
							<p>
								500 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								8
							</p>
						</td>
						<td>
							<p>
								在裁判点乱丢杂物垃圾
							</p>
							<p>
								Littering&nbsp;at&nbsp;marshals&nbsp;posts
							</p>
						</td>
						<td>
							<p>
								500 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								9
							</p>
						</td>
						<td>
							<p>
								在禁止吸烟区域吸烟
							</p>
							<p>
								Smoking&nbsp;in&nbsp;non-smoking&nbsp;areas
							</p>
						</td>
						<td>
							<p>
								500 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								10
							</p>
						</td>
						<td>
							<p>
								物资设备未归还
							</p>
							<p>
								Non-return&nbsp;of&nbsp;equipment
							</p>
						</td>
						<td>
							<p>
								1,500 元+物资设备原价/件
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								11
							</p>
						</td>
						<td>
							<p>
								损坏物资设备
							</p>
							<p>
								Damage to&nbsp;equipment
							</p>
						</td>
						<td>
							<p>
								1,500 元+物资设备原价/件
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								12
							</p>
						</td>
						<td>
							<p>
								在场地内超速行驶/漂移(未经允许)
							</p>
							<p>
								Speeding/Drifting&nbsp;on&nbsp;site&nbsp;without&nbsp;permission
							</p>
						</td>
						<td>
							<p>
								2,000 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								13
							</p>
						</td>
						<td>
							<p>
								在禁停区域停车
							</p>
							<p>
								Parking in&nbsp;restricted&nbsp;areas
							</p>
						</td>
						<td>
							<p>
								1,500 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								14
							</p>
						</td>
						<td>
							<p>
								活动方留下受限制物品(如机油、冷却液等)
							</p>
							<p>
								Teams&nbsp;leaving&nbsp;restricted items
							</p>
						</td>
						<td>
							<p>
								2,000 元/件
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								15
							</p>
						</td>
						<td>
							<p>
								无法更换和清洁赛道基础设施(如弯心防撞杆等)
							</p>
							<p>
								Failure to replace and tidy&nbsp;track&nbsp;infrastructure&nbsp;(such&nbsp;as bollards)
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								1,500 元/件
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								16
							</p>
						</td>
						<td>
							<p>
								擅自移动或更改国际汽联相关安全基础设施&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Removal&nbsp;of&nbsp;FIA&nbsp;related&nbsp;safety&nbsp;infrastructure
							</p>
						</td>
						<td>
							<p>
								20,000 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								17
							</p>
						</td>
						<td>
							<p>
								未穿戴正确的防护装备
							</p>
							<p>
								Failure&nbsp;to&nbsp;wear&nbsp;the&nbsp;correct&nbsp;protective&nbsp;clothing
							</p>
						</td>
						<td>
							<p>
								500 元/次
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								18
							</p>
						</td>
						<td>
							<p>
								未采用合适的防护措施
							</p>
							<p>
								Failure&nbsp;to&nbsp;follow&nbsp;correct&nbsp;health&nbsp;&amp;safety&nbsp;measures
							</p>
						</td>
						<td>
							<p>
								500 元/次
							</p>
						</td>
					</tr>
				</tbody>
			</table>
			<p>
				&nbsp;
			</p>
		</div>
		<p style="text-indent:2em;">
			<br />
		</p>
		<p style="text-indent:2em;">
			附件&nbsp;2：浙江国际赛车场赛道固定资产损坏修复费表
		</p>
		<p style="text-indent:2em;">
			<br />
		</p>
		<p style="text-indent:2em;">
			<br />
		</p>
		<p style="text-indent:2em;">
			<table border="1">
				<tbody>
					<tr>
						<td>
							<p>
								序号
							</p>
						</td>
						<td>
							<p>
								工作内容
							</p>
						</td>
						<td>
							<p>
								单位
							</p>
						</td>
						<td>
							<p>
								数量
							</p>
						</td>
						<td>
							<p>
								单价
							</p>
						</td>
						<td>
							<p>
								合价
							</p>
						</td>
						<td>
							<p>
								备注
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								&nbsp;
							</p>
							<p>
								1
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								波形护栏
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								根
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								&nbsp;
							</p>
							<p>
								2000
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								只包含一块4 米波&nbsp;板&nbsp;的拆除与更换，&nbsp;不包含立柱的拆除&nbsp;与更换
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								2
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								波形护栏
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								根
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								3500
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								包含一块4 米波板&nbsp;的拆除与更换及相&nbsp;关立柱的更换
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								&nbsp;
							</p>
							<p>
								3
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								&nbsp;
							</p>
							<p>
								碎片挡网
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								&nbsp;
							</p>
							<p>
								片
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								&nbsp;
							</p>
							<p>
								10000
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								包含一片4 米长网&nbsp;片&nbsp;的拆除与更换及&nbsp;相&nbsp;关立柱的拆除与&nbsp;更换
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								4
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								轮胎墙调整
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								米
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								250
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								传未送带损坏，只调&nbsp;整轮胎
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								5
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								轮胎墙修补
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								米
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
							<p>
								800
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								包含轮胎的拆除与&nbsp;安装，传送带的拆&nbsp;除与更换
							</p>
						</td>
					</tr>
					<tr>
						<td>
							<p>
								6
							</p>
						</td>
						<td>
							<p>
								T1&nbsp;弯广场防护玻璃
							</p>
						</td>
						<td>
							<p>
								块
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								685
							</p>
						</td>
						<td>
							<p>
								&nbsp;
							</p>
						</td>
						<td>
							<p>
								包含一块玻璃拆除与更换
							</p>
						</td>
					</tr>
				</tbody>
			</table>
		</p>
		<p style="text-indent:2em;">
			<br />
		</p>
		<p style="text-indent:2em;">
			注：以上价格为赛道易损部分修复费用，如有新增损坏项目将以实际修复发生费用为准
		</p>
	</div> -->
</template>
<script>
	import content from '../../api/content';
	export default {
		data () {
			return {
				info:'',
			}
		},
		created () {
			this.$store.commit('param/show', false)

			var apppar={
				title:this.$route.meta.title
			}
			this.$appService.changeTitle(apppar)
			this.getAgreement(6)
		},
		methods: {
			getAgreement(id){
				content.getAgreement({id:id}).then(res => {
					this.info=res.data.data
				})
			},
		}
	};
</script>
<style lang="scss">
	.agreement_page {
		padding: 10px;
	}
</style>